import {
  ARCHIVING_DATE_ROUTE_TYPES,
  ARCHIVING_VALUE_ROUTE_TYPES,
  type ElementType,
} from '@record-fill';
import type { ArchivingField, ArchivingRoute, RouteEligibility } from '../model/archiving.types';

const DATE_ROUTE_TYPES: ReadonlySet<ElementType> = new Set(ARCHIVING_DATE_ROUTE_TYPES);
const VALUE_ROUTE_TYPES: ReadonlySet<ElementType> = new Set(ARCHIVING_VALUE_ROUTE_TYPES);

export function getRouteEligibility(type: ElementType): RouteEligibility | null {
  if (DATE_ROUTE_TYPES.has(type)) return 'date';
  if (VALUE_ROUTE_TYPES.has(type)) return 'value';
  return null;
}

export function getValueRouteFields(fields: ReadonlyArray<ArchivingField>): ArchivingField[] {
  return fields.filter((field) => getRouteEligibility(field.type) === 'value');
}

export function isFieldUsedByOtherRoute(
  routes: ReadonlyArray<ArchivingRoute>,
  routeIndex: number,
  fieldName: string
): boolean {
  return routes.some((route, index) => index !== routeIndex && route.fieldName === fieldName);
}

export function excludeFieldsUsedByOtherRoutes(
  fields: ReadonlyArray<ArchivingField>,
  routes: ReadonlyArray<ArchivingRoute>,
  routeIndex: number
): ArchivingField[] {
  return fields.filter((field) => !isFieldUsedByOtherRoute(routes, routeIndex, field.name));
}
